import { FC } from "react";

interface ITabItemProps {
  currentContent: string;
  onSetContent: (content: string) => void;
  tabContent: string;
  tabLabel: string;
}

const TabItem: FC<ITabItemProps> = ({
  currentContent,
  onSetContent,
  tabContent,
  tabLabel,
}) => {
  return (
    <li className={'' + (
      currentContent === tabContent
        ? ' active'
        : ''
    )}>
      <a
        className="btn-item"
        onClick={() => onSetContent(tabContent)}
      >
        {tabLabel}
      </a>
    </li>
  );
}

export default TabItem;
